import { createStyles } from '@mantine/core';
import { type ComponentProps, forwardRef, type PropsWithChildren } from 'react';

const useStyles = createStyles((theme) => ({
  container: {
    maxWidth: theme.other.layout.maxWidth,
    width: '100%',
    paddingLeft: theme.other.layout.paddingLg,
    paddingRight: theme.other.layout.paddingLg,
    margin: '0 auto',

    [theme.fn.smallerThan('lg')]: {
      paddingLeft: theme.other.layout.paddingMd,
      paddingRight: theme.other.layout.paddingMd,
    },
    [theme.fn.smallerThan('md')]: {
      paddingLeft: theme.other.layout.paddingSm,
      paddingRight: theme.other.layout.paddingSm,
    },
  },
  containerNested: {
    paddingLeft: theme.other.layout.paddingLg,
    paddingRight: theme.other.layout.paddingLg,
    marginLeft: -theme.other.layout.paddingLg,
    marginRight: -theme.other.layout.paddingLg,

    [theme.fn.smallerThan('lg')]: {
      paddingLeft: theme.other.layout.paddingMd,
      paddingRight: theme.other.layout.paddingMd,
      marginLeft: -theme.other.layout.paddingMd,
      marginRight: -theme.other.layout.paddingMd,
    },
    [theme.fn.smallerThan('md')]: {
      paddingLeft: theme.other.layout.paddingSm,
      paddingRight: theme.other.layout.paddingSm,
      marginLeft: -theme.other.layout.paddingSm,
      marginRight: -theme.other.layout.paddingSm,
    },
  },
}));

const Container = forwardRef<HTMLDivElement, ComponentProps<'div'>>(
  ({ children, className, ...props }, ref) => {
    const { classes, cx } = useStyles();

    return (
      <div ref={ref} className={cx(classes.container, className)} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

function ContainerNested({ children, className }: PropsWithChildren<{ className?: string }>) {
  const { classes, cx } = useStyles();

  return <div className={cx(classes.containerNested, className)}>{children}</div>;
}

export default Container;

export { ContainerNested };
